// src/components/popups/DeleteChatDrawer.js

import React from 'react';
import './DeleteChatDrawer.css'; // ✅ Use dedicated drawer styles

function DeleteChatDrawer({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div className="deletechat-overlay">
      <div className="deletechat-popup">
        <div className="deletechat-header">
          <h3>Delete Chat</h3>
        </div>
        <div className="deletechat-body">
          <p>Are you sure you want to delete this chat? This action cannot be undone.</p>
        </div>
        <div className="deletechat-footer">
          <button className="deletechat-cancel-btn" onClick={onClose}>Cancel</button>
          <button className="deletechat-confirm-btn" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
}

export default DeleteChatDrawer;
